import {useMemo, useState} from "../../__snowpack__/pkg/react.js";
import {parse} from "../../__snowpack__/pkg/query-string.js";
import {createModel} from "../../__snowpack__/pkg/hox.js";
import {Modal} from "../../__snowpack__/pkg/antd.js";
import {isEmpty, filter} from "../../__snowpack__/pkg/lodash.js";
import {axios} from "../lib/axios.js";
import {useUpdateRoute} from "../lib/useIframe.js";
import {persistLocalStorageWithLifetime, PERSIST_LIFETIME_KEY} from "../config/order/persist.js";
export const useCountryInfo = (formatMessage) => {
  const {updateRoute} = useUpdateRoute();
  const [CountryList, setCountryList] = useState([]);
  const [currencyCodeToSymbol, setCurrencyCodeToSymbol] = useState({});
  const [countryLink, setCountryLink] = useState({});
  const getCountryLink = async () => {
    const localLink = window.localStorage.countryLink ? JSON.parse(window.localStorage.countryLink) : null;
    if (localLink) {
      setCountryLink(localLink);
      return localLink;
    } else {
      const {data} = await axios.get("saas/country/get");
      window.localStorage.setItem("countryLink", JSON.stringify(data));
      setCountryLink(data);
      return data;
    }
  };
  const country = !isEmpty(window.localStorage.userCountryInfo) ? parse(window.localStorage.userCountryInfo) : {};
  const {
    email,
    mobile,
    merchant = {}
  } = !isEmpty(window.localStorage.userInfo) ? JSON.parse(window.localStorage.userInfo) : {
    email: null,
    mobile: null,
    merchant: {merchantLogoUrl: null, brandLogoUrl: null}
  };
  const generateCodeToSymbol = (list) => {
    let tempObj = {};
    list.forEach((country2) => {
      tempObj[country2.currencyCode] = country2.currencySymbol;
    });
    setCurrencyCodeToSymbol(tempObj);
  };
  const getLocalCountryList = () => {
    const countryList = persistLocalStorageWithLifetime.get(PERSIST_LIFETIME_KEY.GLOBAL_COUNTRY_LIST);
    let isCountryEmpty = true;
    if (countryList?.length) {
      generateCodeToSymbol(countryList);
      isCountryEmpty = false;
    }
    return {
      list: countryList,
      isCountryEmpty
    };
  };
  const getCountryList = async () => {
    const {list, isCountryEmpty} = getLocalCountryList();
    if (isCountryEmpty) {
      const {data} = await axios.get("saas/country/list");
      persistLocalStorageWithLifetime.set(PERSIST_LIFETIME_KEY.GLOBAL_COUNTRY_LIST, data, 24 * 60 * 60 * 1e3);
      generateCodeToSymbol(data);
      setCountryList(data);
    } else {
      setCountryList(list);
      generateCodeToSymbol(list);
    }
  };
  const getCountryInfo = useMemo(() => {
    if (!isEmpty(country)) {
      return Boolean(["ID", "CN"].includes(country.countryCode));
    } else {
      return true;
    }
  }, [country.countryCode]);
  const openModalInfo = async (packageBool) => {
    if (!["ID", "CN"].includes(country.countryCode)) {
      await getCountryLink();
    }
    if (packageBool > 0 && packageBool < 7) {
      Modal.confirm({
        title: formatMessage({id: "globalsNotification"}),
        content: formatMessage({id: "globalsContactUsPackage"}),
        okText: formatMessage({id: "globalsContactNow"}),
        cancelText: formatMessage({id: "globalsLater"}),
        onOk: () => {
          window.open(countryLink.officialWebsite);
        },
        onCancel: () => {
          Modal.destroyAll();
        }
      });
    } else {
      updateRoute("package-expired");
    }
  };
  return {
    getCountryInfo,
    openModalInfo,
    country,
    email,
    mobile,
    merchant,
    CountryList: filter(CountryList, (item) => !["TW"].includes(item.countryCode)),
    fetchCountryList: getCountryList,
    currencyCodeToSymbol,
    countryLink,
    getCountryLink
  };
};
export const getUseInfo = (formatMessage) => {
  const [userInfo, setUserInfo] = useState({});
  const getIamUserInfo = async () => {
    const {data, code} = await axios.get("/saas/user/iam-userinfo");
    if (code === "SUCCESS") {
      setUserInfo(data);
    }
  };
  return {
    userInfo,
    getIamUserInfo
  };
};
export const useCountryInfoModel = createModel(useCountryInfo);
export const getUseInfoModel = createModel(getUseInfo);
